import { Ban, CheckCircle, CircleDashed, Clock, XCircle } from "lucide-react";

export const statusConfig: Record<
	string,
	{
		label: string;
		type: "default" | "info" | "warning" | "success" | "error";
		icon: typeof CheckCircle;
	}
> = {
	pending_approval: { label: "Pending Approval", type: "warning", icon: Clock },
	approved: { label: "Approved", type: "info", icon: CheckCircle },
	processing: { label: "Processing", type: "info", icon: CircleDashed },
	completed: { label: "Completed", type: "success", icon: CheckCircle },
	failed: { label: "Failed", type: "error", icon: XCircle },
	rejected: { label: "Rejected", type: "error", icon: Ban },
	cancelled: { label: "Cancelled", type: "default", icon: XCircle },
};
